import AuthImage from "../AuthImage";

function Logo({ src, name, show }) {
  if (!show) return <span className="text-[9px] text-slate-300 italic">No logo or name</span>;
  if (!src) return <span className="text-[11px] font-bold text-slate-900 truncate">{name}</span>;
  const cls = "h-6 max-w-[90px] object-contain object-left";
  return src.startsWith("/api/files/")
    ? <AuthImage path={src} alt="Logo" className={cls} data-testid="email-mock-logo" />
    : <img src={src.startsWith("http") ? src : `${process.env.REACT_APP_BACKEND_URL}${src}`} alt="Logo" className={cls} data-testid="email-mock-logo" />;
}

/** Instant mock-up of a client e-mail styled by the same preset: header bar, accent rule, button, footer and credit. */
export function EmailBrandMockup({ opts, tenant, pairs = [] }) {
  const t = tenant || {};
  const name = opts.show_company_name ? (opts.company_name || t.company_name || "Company name") : "";
  const logo = opts.logo_size === "none" ? "" : (opts.logo_url || t.logo_url || "");
  const footer = opts.show_footer ? (opts.footer_text || t.footer_text || "") : "";
  const footerLines = footer.split("\n").map((l) => l.trim()).filter(Boolean);
  const credit = !(opts.hide_platform_branding && t.white_label_allowed);
  const accent = (/^#[0-9a-fA-F]{6}$/.test(opts.accent_color || "") ? opts.accent_color : "") || t.primary_color || "#1D4ED8";
  const pair = pairs.find((p) => p.key === (opts.font_pair || "classic"));
  const from = name || t.company_name || "us";
  return (
    <div className="rounded-md border border-border bg-slate-100 dark:bg-slate-800 p-3" data-testid="email-brand-mockup">
      <p className="text-[10px] uppercase tracking-wide text-muted-foreground mb-2">Live preview · client e-mail</p>
      <div className="mx-auto rounded-md bg-slate-50 p-3" style={{ width: 300 }}>
        <div className="rounded-t-md bg-white px-3 py-2 flex items-center min-h-[36px]" style={{ borderBottom: `3px solid ${accent}` }} data-testid="email-mock-header">
          <Logo src={logo} name={name} show={!!(logo || name)} />
        </div>
        <div className="bg-white border border-t-0 border-slate-200 rounded-b-md px-3 py-3 text-slate-700">
          <p className="text-[10px] font-semibold text-slate-900" style={{ fontFamily: pair?.css_heading }} data-testid="email-mock-title">Your quote QTE-0001 is ready</p>
          <p className="text-[8px] mt-1.5 leading-snug" style={{ fontFamily: pair?.css_body }}>Hi there, please find your quote attached. Let us know if you have any questions.</p>
          <div className="text-center my-3"><span className="inline-block rounded px-3 py-1 text-[8px] font-semibold text-white" style={{ backgroundColor: accent }} data-testid="email-mock-button">Open in your portal</span></div>
          <div className="border-t border-slate-200 pt-2 text-[7.5px] text-slate-500 leading-snug" data-testid="email-mock-footer">
            <p>This is an automated notification from {from}.</p>
            {footerLines.map((l, i) => <p key={i}>{l}</p>)}
            <p><span style={{ color: accent }}>Open Portal</span></p>
            {credit && <p className="text-slate-400" data-testid="email-mock-credit">Powered by Fixlr</p>}
          </div>
        </div>
      </div>
    </div>
  );
}
